// extracted by mini-css-extract-plugin
module.exports = {"header":"_5e7d0d6","icon":"_ebff01c"};